module.exports = __webpack_public_path__ + "img/img_3.9055f106.jpeg";